import PreClearanceForm from '@app/components/apps/PreClearance/PreClearanceForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';

const CreatePreClearancePage = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Product Registration Product');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/pre-clearance',
      breadcrumbName: 'Pre-Clearance',
    },
    {
      path: '/add-pre-clearance',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <PreClearanceForm
          editable={true}
          pageTitle={'Create PreClearance'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default CreatePreClearancePage;
